import React from 'react';

import * as Antd from 'antd';
import * as SYS from './';

export const UserForm = props => {
    const [form] = Antd.Form.useForm();

    const layout = {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
    };

    const tailLayout = {
        wrapperCol: { span: 18, offset: 6 },
    };

    return (
        <Antd.Form
            {...layout}
            form={form}
            initialValues={props.initialValues}
            onFinish={values => {
                if (props.onSuccess) {
                    props.onSuccess(values);
                }
            }}
            onFinishFailed={(err) => {
                console.log(err);
            }}
        >
            {props.initialValues && props.initialValues.id
                ? <Antd.Form.Item name="id" label="ID">
                    <Antd.Input disabled={true} />
                </Antd.Form.Item>
                : null}
            <Antd.Form.Item
                name="username"
                label="Username"
                rules={[{ required: true }]}
            >
                <Antd.Input />
            </Antd.Form.Item>
            <Antd.Form.Item
                name="lastName"
                label="Last name"
                rules={[{ required: true }]}
            >
                <Antd.Input />
            </Antd.Form.Item>
            <Antd.Form.Item
                name="firstName"
                label="First name"
                rules={[{ required: true }]}
            >
                <Antd.Input />
            </Antd.Form.Item>
            <Antd.Form.Item
                name="roles"
                label="Roles"
                rules={[{ required: true }]}
            >
                <SYS.UserRoleSelect
                    mode="tags"
                />
            </Antd.Form.Item>

            {props.initialValues 
                && !props.initialValues.password
                && props.initialValues.password !== ""
                ? <Antd.Form.Item
                    name="password"
                    label="Password"
                >
                    <Antd.Input />
                </Antd.Form.Item>
                : null}

            <Antd.Form.Item
                {...tailLayout}
                style={{
                    marginTop: 10
                }}
            >
                <Antd.Button
                    type="primary"
                    htmlType="submit"
                >
                    Submit
                </Antd.Button>
            </Antd.Form.Item>
        </Antd.Form >
    );
}